import { featureMap } from '../data';

export const defaultState = () => ({
	step: 0,
	forward: true,
	complete: false,
	extraFeatures: featureMap.filter((f) => f.plugin).map((f) => f.slug),
});

const state = defaultState();

export default state;
